import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { Consent } from "./getConsentSummaryForCandidate";

export interface StartConsentResponse extends BackendResponse {
  item: Consent;
}
export interface StartConsentParameters extends NextApiParams {
  consentType: number;
}

export const startConsentForCandidate = withNextApi<
StartConsentResponse,
StartConsentParameters
>("/cvp/CvpStartConsent");
